import { map } from "lodash";
import classNames from "classnames";

export interface TagAttachmentsTypes {
  tags: Array<{
    id: string;
    name: string;
    ["reader_tag?"]?: boolean | null;
  }>;
}

function TagAttachments({ tags }: TagAttachmentsTypes) {
  return (
    <div className="activity-tags pb-2 flex gap-2 flex-wrap empty:hidden">
      {map(tags, (tag, index) => (
        <span
          key={index}
          className={classNames("tag", { "tag--reader": tag["reader_tag?"] })}
        >
          <div className="label">
            <a
              href={`/activitystreams/all?tag=${encodeURIComponent(tag.name)}`}
            >
              {tag.name}
            </a>
          </div>
        </span>
      ))}
    </div>
  );
}

export default TagAttachments;
